import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowRight, FiCheckCircle,  FiClipboard, FiTool ,FiActivity, FiCloud, FiLock, FiBarChart, FiServer, FiUsers  } from 'react-icons/fi';
import './Home.css';
import ConstructionSiteImg from '../Assets/image.png';

function Home() {
  const navigate = useNavigate();
  

  const features = [
    {
      icon: <FiActivity className="feature-icon" />,
      title: "Real-time Monitoring",
      text: "Track construction progress with live site updates and IoT sensor data"
    },
    {
      icon: <FiCloud className="feature-icon" />,
      title: "Cloud Collaboration",
      text: "Seamless document sharing and team communication across sites"
    },
    {
      icon: <FiLock className="feature-icon" />,
      title: "Enhanced Security",
      text: "Military-grade encryption for all your project data and communications"
    },
    {
      icon: <FiBarChart className="feature-icon" />,
      title: "Smart Analytics",
      text: "AI-powered insights and predictive resource allocation"
    },
    {
      icon: <FiServer className="feature-icon" />,
      title: "Unlimited Storage",
      text: "Secure cloud storage for blueprints, photos, and documents"
    },
    {
      icon: <FiUsers className="feature-icon" />,
      title: "Team Management",
      text: "Role-based access control and workforce scheduling"
    }
  ];

  return (
    <div className="home-page">
      {/* Hero Section */}
      <motion.div 
        className="hero-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="hero-content">
          <motion.div 
            className="hero-text"
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="hero-title">
              Transform Your 
              <span className="highlight"> Construction</span> 
              Management
            </h1>
            <p className="hero-subtitle">
              Streamline operations, enhance collaboration, and boost productivity 
              with our comprehensive construction management platform
            </p>
            <div className="hero-cta">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="primary-btn"
                onClick={() => navigate('/register')}
              >
                Get Started <FiArrowRight />
              </motion.button>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="secondary-btn"
                onClick={() => navigate('/demo')}
              >
                Watch Demo
              </motion.button>
            </div>
          </motion.div>

          <motion.div 
            className="hero-image"
            initial={{ x: 100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <img 
              src={ConstructionSiteImg} 
              alt="Construction Management" 
              className="animated-img"
            />
            <div className="gradient-overlay" />
          </motion.div>
        </div>
      </motion.div>

      {/* Features Section */}
      <section className="features-section">
      <motion.div 
        className="section-header"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <h2 className="section-title">Construction Management Evolved</h2>
        <p className="section-subtitle">Modern tools for modern construction challenges</p>
      </motion.div>

      <div className="features-grid">
        {features.map((feature, index) => (
          <motion.div 
            key={index}
            className="feature-card"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ delay: index * 0.1 }}
          >
            <div className="feature-icon-container">
              {feature.icon}
            </div>
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-text">{feature.text}</p>
          </motion.div>
        ))}
      </div>
    </section>

      {/* Stats Section */}
      <motion.section 
        className="stats-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
      >
        <div className="stats-container">
          <div className="stat-item">
            <h3>500+</h3>
            <p>Projects Managed</p>
          </div>
          <div className="stat-item">
            <h3>95%</h3>
            <p>On-Time Completion</p>
          </div>
          <div className="stat-item">
            <h3>1M+</h3>
            <p>Daily Updates</p>
          </div>
        </div>
      </motion.section>

      {/* CTA Section */}
      <motion.section 
        className="cta-section"
        initial={{ y: 50, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true }}
      >
        <div className="cta-content">
          <h2>Ready to Transform Your Construction Management?</h2>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="cta-btn"
            onClick={() => navigate('/register')}
          >
            Start Free Trial
          </motion.button>
        </div>
      </motion.section>
    </div>
  );
}

export default Home;